import { render, staticRenderFns } from "./CR_oceanShipping.vue?vue&type=template&id=0d33aa45&"
import script from "./CR_oceanShipping.vue?vue&type=script&lang=js&"
export * from "./CR_oceanShipping.vue?vue&type=script&lang=js&"
import style0 from "./CR_oceanShipping.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports